import { useSelector } from 'react-redux';
import { DecodeHtml } from './../../utils/decodeHtml';

const WhyUniten = () => {


    const state = useSelector(state => state.aboutUnitenContent)



    const aboutUniten = state?.data?.properties

    const title = aboutUniten?.title
    const description = DecodeHtml({ html: aboutUniten?.richTextContent?.markup })

   
    return (
        <div className="flex flex-col gap-5 ">
            <h1 className="w-auto max-w-[30ch] text-3xl font-bold text-slate-900  2xl:text-5xl !leading-tight">{title}</h1>

            <p className='w-auto whitespace-pre-line'>{description}</p>

            {/* {
                paragraphs.map((p, i) => (
                    <p key={i} className="w-auto text-[#071946B2] text-justify   text-base font-normal leading-normal">{p}</p>
                ))
            }
            <Video path={path1} />
            <Video path={path2} /> */}
            {/* <button className="px-8 py-4 w-fit bg-red-800 rounded justify-center items-center gap-4 flex">
                <span className="text-white text-base font-bold capitalize flex items-center gap-3">Apply now <FaArrowRight /></span>
            </button> */}
        </div>
    )
}

export default WhyUniten